const setupChatWindow = ({ userName, userEmail }) => {
	window.LC_API = window.LC_API || {}

	window.LC_API.on_before_load = function() {
		window.LC_API.hide_chat_window()
	}

	window.LC_API.on_chat_window_minimized = function() {
		window.LC_API.hide_chat_window()
	}

	window.__lc = window.__lc || {}
	window.__lc.license = 1520
	window.__lc.params = [
		{ name: 'name', value: userName },
		{ name: 'email', value: userEmail }
	]
	;(function() {
		var lc = document.createElement('script')
		lc.type = 'text/javascript'
		lc.async = true
		lc.src =
			('https:' === document.location.protocol ? 'https://' : 'http://') +
			'cdn.livechatinc.com/staging/tracking.js'
		var s = document.getElementsByTagName('script')[0]
		s.parentNode.insertBefore(lc, s)
	})()
}

export default setupChatWindow



// WEBPACK FOOTER //
// ./src/utils/setupChatWindow.js